import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { QuillEditorComponent } from 'ngx-quill';

@Component({
  selector: 'app-validated-text-editor',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    QuillEditorComponent,
  ],
  templateUrl: './validated-text-editor.component.html',
  styleUrl: './validated-text-editor.component.scss',
})
export class ValidatedTextEditorComponent {
  label = input.required<string>();
  inputFormControlName = input.required<string>();
  inputFormControl = input.required<FormControl>();
  maxLength = input<number>();
  validationTrainslations = input<{ [key: string]: string }>();
  leaveSpaceForValidation = input<boolean>(false);
  placeholder = input<string>('');

  readonly isDisabled = computed<boolean>(
    () => this.inputFormControl().disabled,
  );

  hasRequiredValidator(): string | boolean {
    return this.inputFormControl().hasValidator(Validators.required);
  }

  errorKeys(): string[] {
    const control = this.inputFormControl();
    return control.errors ? Object.keys(control.errors) : [];
  }

  getErrorMessage(errorKey: string): string {
    return this.validationTrainslations()?.[errorKey] ?? errorKey;
  }
}
